import styled from 'styled-components';

export const ContentContainer = styled.div`
  position: relative;
`;

export const SectionContainer = styled.div`
  position: relative;
  z-index: 1;
`;
